export const HISTORY_DISPLAY_LIMIT = 8;
